<template>
  <div class>
    <div class="jm-white-container">
      <div class="col-lg-10 mx-auto">
        <div class="row">
          <div class="col-md-12 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-container w-100">
                <input v-model="hourl" type="text" placeholder="URL" />
              </div>
              <Tooltip :title="`URL generated after HO installation for this cinema`"  />
            </div>
            <p class="error_msg">Invaid Entry</p>
          </div>

          <div class="col-md-12 mb-4">
            <div class="row">
              <div class="col-md-6 mb-4">
                <div class="d-flex align-items-center">
                  <div class="input-container w-100">
                    <input v-model="username" type="text" placeholder="Key" />
                  </div>
                  <Tooltip :title="`Key generated for this cinema in HO installation`"  />
                </div>
                <p class="error_msg">Invaid Entry</p>
              </div>

              <div class="col-md-6 mb-4">
                <div class="d-flex align-items-center">
                  <div class="input-container w-100">
                    <input v-model="password" type="text" placeholder="Pass code" />
                  </div>
                  <Tooltip :title="`Passcode generated for this cinema in HO installation`"  />
                </div>
                <p class="error_msg">Invaid Entry</p>
              </div>

              <div class="col-md-12 text-center">
                <router-link
                  to="cinema-database-configuration"
                  class="btn-blue-lg w-25 ml-2"
                >Proceed</router-link>
                <!-- <router-link to v-on:click.native="onSubmit()" class="btn-blue-lg w-25 ml-2">Proceed</router-link> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SetupService from "@/services/SetupService";

export default {
  data() {
    return {
      hourl: "",
      username: "",
      password: ""
    };
  },
  methods: {
    onSubmit: function() {
      let payload = {
        hourl: this.hourl,
        username: this.username,
        password: this.password
      };
      SetupService.loginCinemaUser(payload)
        .then(result => {
          const { data } = result;
          if (data.status) {
            this.$router.push({ path: "cinema-database-configuration" });
          }
        })
        .catch(err => {
          console.log("err :", err);
        });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/cinemaInstallation/cinemaUrlInstallation.vue